module.exports = __webpack_public_path__ + "img/GD_PNG_WHITE.99750458.png";